import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useMemo } from "react";
import Searcher from "../../../searcher/index.js";
import { SearcherItem, SearcherItemWithMaxWidth } from "../../../searcher/styled.js";
import useUp from "../../../../../../hooks/media/useUp.js";
import SearcherFlightHotelAccommodationInput from "../../components/accommodation-input/index.js";
import SearcherFlightHotelButton from "../../components/button/index.js";
import SearcherFlightHotelClassesInput from "../../components/classes-input/index.js";
import SearcherFlightHotelDatesInput from "../../components/dates-input/index.js";
import SearcherFlightHotelDestinationInput from "../../components/destination-input/index.js";
import SearcherFlightHotelDiscountsInput from "../../components/discounts-input/index.js";
import SearcherFlightHotelOriginInput from "../../components/origin-input/index.js";
import SearcherFlightHotelForm from "../../components/searcher-form/index.js";
import { useSearcherFlightHotelProps } from "../../context/index.js";
import useSearcherFlightHotelView from "../../hooks/useSearcherFlightHotelView.js";
import * as S from "./styled.js";
const SearcherFlightHotelDesktopView = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config , destination  } = props ?? {};
    const { onModal =false , hideDestination =false  } = config ?? {};
    const { mustShowClasses , mustShowDiscounts  } = useSearcherFlightHotelView();
    const variant = useMemo(()=>!!mustShowClasses || !!mustShowDiscounts ? 'medium' : 'larger', [
        mustShowClasses,
        mustShowDiscounts
    ]);
    const isXl = useUp('xl');
    return /*#__PURE__*/ _jsxs(Searcher, {
        "data-testid": "SearcherFlightHotel",
        MiddleComponent: S.SearcherMiddleWrapper,
        middleProps: {
            className: classNames({
                'has-classes': !!mustShowClasses
            }),
            $isModal: onModal
        },
        children: [
            /*#__PURE__*/ _jsx(SearcherItem, {
                $variant: variant,
                $order: 1,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelOriginInput, {})
            }),
            (!hideDestination || !destination) && /*#__PURE__*/ _jsx(SearcherItem, {
                $variant: variant,
                $order: 2,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelDestinationInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItem, {
                $variant: variant,
                $order: 3,
                $grow: true,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelDatesInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItemWithMaxWidth, {
                $variant: variant,
                $order: 4,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelAccommodationInput, {})
            }),
            mustShowClasses && /*#__PURE__*/ _jsx(SearcherItem, {
                $variant: variant,
                $order: 7,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelClassesInput, {})
            }),
            mustShowDiscounts && /*#__PURE__*/ _jsx(SearcherItem, {
                $variant: variant,
                $order: mustShowClasses ? 8 : 5,
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelDiscountsInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherFlightHotelButton, {
                order: isXl ? 6 : 9
            })
        ]
    });
};
const SearcherFlightHotelDesktop = (props)=>/*#__PURE__*/ _jsx(SearcherFlightHotelForm, {
        ...props,
        children: /*#__PURE__*/ _jsx(SearcherFlightHotelDesktopView, {})
    });
export default SearcherFlightHotelDesktop;

//# sourceMappingURL=index.js.map